const prefix = 'notify/'
const type = {
    GET_LIST_NOTIFY: prefix + 'GET_LIST_NOTIFY',
    GET_LIST_NOTIFY_DONE: prefix + 'GET_LIST_NOTIFY_DONE',
    SET_READ_NOTIFY: prefix + 'SET_READ_NOTIFY',
    GET_DATA_TASK_IN_NOTIFY: prefix + 'GET_DATA_TASK_IN_NOTIFY',
    UPDATE_TOTAL_INDEX: prefix + 'UPDATE_TOTAL_INDEX',
    SET_READ_ALL_NOTIFY: prefix + 'SET_READ_ALL_NOTIFY',
}
const action = {
    updateTotalIndex: (total, index) => {
        return {
            type: type.UPDATE_TOTAL_INDEX,
            payload: {
                total,
                index,
            },
        }
    },
    getListNotify: (page_number, page_size, isRefresh) => {
        return {
            type: type.GET_LIST_NOTIFY,
            payload: {
                page_number,
                page_size,
                isRefresh,
            },
        }
    },
    getListNotifyDone: (data, isRefresh) => {
        return {
            type: type.GET_LIST_NOTIFY_DONE,
            payload: {
                data,
                isRefresh,
            },
        }
    },
    setReadNotify: id => {
        return {
            type: type.SET_READ_NOTIFY,
            payload: {
                id,
            },
        }
    },
    getDataTaskInNotify: (id, idOfTask) => {
        return {
            type: type.GET_DATA_TASK_IN_NOTIFY,
            payload: {
                id,
                idOfTask,
            },
        }
    },
    setReadAllAPI: () => {
        return {
            type: type.SET_READ_ALL_NOTIFY,
        }
    },
}

export default {
    type,
    action,
}
